import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./hooks/useAuth";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";

import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import AuthLayout from "./components/layouts/AuthLayout";
import DashboardLayout from "./components/layouts/DashboardLayout";
import PublicLayout from "./components/layouts/PublicLayout";
import { ToastContainer } from "react-toastify";
import ProfilePage from "./pages/ProfilePage";
import { pageRoute, siteData } from "./utils/common";
import ProductAddPage from "./pages/ProductAddPage";
import ProductListPage from "./pages/ProductListPage";
import { setFavicon } from "./utils/setFavicon";
import ForgotPassword from "./pages/ForgotPassword";
import VendorBusinessDetails from "./pages/VendorBusinessDetails";
import ResetPassword from "./pages/ResetPassword";
import ProductForm from "./pages/Productmanager";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import VerifyEmail from "./components/VerifyEmail";
import VendorPayoutForm from "./components/VendorPayoutForm";
import ReviewList from "./pages/ReviewList";
import VendorOrderManagement from "./pages/VendorOrderManagement2";
// import VendorReturnList from "./pages/VendorReturnList";
import BrandManagement from "./pages/BrandManagement";
import VendorEarnings from "./pages/VendorEarnings";
import Dashboard from "./pages/DashboardPage";
import OrderDetails from "./pages/OrderDetails";
 
function App() {
  useEffect(() => {
    setFavicon('/logo.png');
  }, [])

  useEffect(() => {
    document.title = siteData.name;
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Auth Pages (Login / Signup) */}
          <Route

            element={
              <PublicRoute>
                <AuthLayout />
              </PublicRoute>
            }
          >
            <Route path={pageRoute.login} element={<Login />} />
            <Route path={'/forgot-password'} element={<ForgotPassword />} />
            <Route path={'/reset-password'} element={<ResetPassword />} />
            <Route path={pageRoute.signUp} element={<SignUp />} />
          </Route>

          {/* Dashboard Pages */}
          <Route

            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >
            <Route path={pageRoute.brandManagement} element={<BrandManagement />} />
            <Route path={pageRoute.dashboard} element={<Dashboard />} />
            <Route path={pageRoute.vendorEarning} element={<VendorEarnings />} />

            <Route path={pageRoute.payoutDetails} element={<VendorPayoutForm />} />
            <Route path={pageRoute.profile} element={<ProfilePage />} />
            <Route path={pageRoute.vendorBusinessDetails} element={<VendorBusinessDetails />} />
            <Route path={pageRoute.productAdd} element={<ProductForm />} />
            <Route path={pageRoute.allReview} element={<ReviewList />} />
            <Route path={pageRoute.productList} element={<ProductListPage />} />
            <Route path={pageRoute.orderList} element={<VendorOrderManagement />} />
            <Route path={`${pageRoute.orderView}:orderId`} element={<OrderDetails />} />
            {/* <Route path={pageRoute.returnList} element={<VendorReturnList />} /> */}
            <Route path={`${pageRoute.productView}:productId`} element={<ProductDetailsPage />} />
            <Route path={`${pageRoute.productEdit}:productId`} element={<ProductForm mode={'edit'} />} />
          </Route>

          {/* Public Website Pages */}
          <Route element={<PublicLayout />}>
            <Route path="/verify-email" element={<VerifyEmail />} />
          </Route>

          {/* Default Redirect */}
          <Route path="*" element={<Navigate to={pageRoute.dashboard} replace />} />
        </Routes>
      </Router>
      <ToastContainer autoClose={1500} style={{ maxWidth: '80%' }} />
    </AuthProvider>
  );
}

export default App;

